<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
    <path v-if="small" d="M7 10l5 5 5-5z" />
    <path v-else d="M4 8.5l8 8 8-8z" />
  </svg>
</template>

<script>
export default {
  name: 'DropDownIcon',
  props: {
    /** サイズ小 */
    small: Boolean,
  },
}
</script>
